import React from 'react';

const CustomMessage = (props) => {
  return (
    <></>
  );
};

export default CustomMessage;